import { useEffect, useState } from "react";
import { getConnectivityState, subscribeConnectivity } from "utils/connectivityStatus";

const COPY = {
  reconnecting: {
    text: "Connecting to Webbieshop... Checking your connection.",
    bg: "#688ad5",
  },
  offline: {
    text: "Unable to reach Webbieshop servers. Please check the network connection. Webbieshop will keep trying automatically.",
    bg: "#b71c1c",
  },
};

// Persistent top-of-app status band — deliberately not a dismissible toast,
// since it reflects an ongoing condition (retrying / offline), not a
// one-off event. Renders nothing once back online.
const ConnectivityBanner = () => {
  const [status, setStatus] = useState(getConnectivityState());

  useEffect(() => subscribeConnectivity(setStatus), []);

  const copy = COPY[status];
  if (!copy) return null;

  return (
    <div
      role="status"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        zIndex: 2000,
        background: copy.bg,
        color: "#fff",
        textAlign: "center",
        fontSize: 13,
        fontWeight: 600,
        padding: "6px 12px",
      }}
    >
      {copy.text}
    </div>
  );
};

export default ConnectivityBanner;
